import { useEffect, useRef, useState, useContext } from "react";
import PropTypes from "prop-types";
import { FontSizeContext } from "../../context/fontSizeContext";
import ClientstoriesData from "../../data/clientstories.json";

const ClientstoriesContainer = ({ classOption = "section-pb" }) => {
    const { fontSize } = useContext(FontSizeContext);
    const textRefs = useRef([]);
    const [defaultSizes, setDefaultSizes] = useState([]);
    const [videoSrc, setVideoSrc] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false); // State to control modal visibility

    const openModal = (param) => (e) => {
        setIsModalOpen(true);
        setVideoSrc(param);
    };
    const closeModal = () => setIsModalOpen(false);

    useEffect(() => {
        if (isModalOpen) {
            // setVideoSrc(
            //     "https://www.youtube.com/embed/oUZnCGZpLyU?si=hjVgsQtFHyANoGb6&autoplay=1"
            // );
        } else {
            setVideoSrc(""); // Stop video when modal is closed
        }
    }, [isModalOpen]);

    const sceneEl = useRef(null);

    const adjustFontSize = (change) => {
        textRefs.current.forEach((element, index) => {
            if (element) {
                const computedStyle = window.getComputedStyle(element);
                const currentSize = parseFloat(computedStyle.fontSize);
                const newSize = currentSize + change;
                element.style.fontSize = `${newSize}px`;
            }
        });
    };

    const resetFontSize = () => {
        textRefs.current.forEach((element, index) => {
            if (element && defaultSizes[index] !== null) {
                element.style.fontSize = `${defaultSizes[index]}px`;
            }
        });
    };

    useEffect(() => {
        const sizes = textRefs.current.map((element) => {
            if (element) {
                const computedStyle = window.getComputedStyle(element);
                return parseFloat(computedStyle.fontSize);
            }
            return null;
        });
        setDefaultSizes(sizes);

        // const parallaxInstance = new Parallax(sceneEl.current, {
        //     relativeInput: true,
        // });

        // parallaxInstance.enable();

        // return () => parallaxInstance.disable();
    }, []);

    useEffect(() => {
        if (fontSize == 0) {
            resetFontSize();
        } else {
            adjustFontSize(fontSize);
        }
    }, [fontSize]);

    return (
        <div className={`testimonial-section position-relative ${classOption}`}>
            <div className="m-10">
                <div className="row justify-content-around">
                    {ClientstoriesData &&
                        ClientstoriesData.map((data, key) => {
                            return data.id % 2 != 0 ? (
                                <div
                                    className="col-xl-6 col-lg-6 col-md-6 col-12 mb-5"
                                    key={key}
                                >
                                    <div
                                        className={
                                            data.class + " radius-box p-3"
                                        }
                                    >
                                        <div className="row mb-1 item-desk">
                                            <img
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    data.authorThumb
                                                }
                                                alt="NeoGrowth "
                                                width={"30%"}
                                                className="radius-box"
                                            />
                                        </div>
                                        <div className="d-flex justify-content-evenly">
                                            <img
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    data.authorThumb
                                                }
                                                alt="NeoGrowth "
                                                width={"30%"}
                                                className="radius-box y-border item-mobile"
                                            />
                                            <div className="align-self-center m-4 text-center">
                                                <h4 className="title text-center">
                                                    <b>{data.name}</b>
                                                </h4>
                                                <p>
                                                    {" "}
                                                    <b>{data.city}</b>
                                                </p>
                                                <button
                                                    className="btn btn-sm btn-primary btn-hover-primary mt-3"
                                                    type="button"
                                                    aria-label="Click to Play"
                                                    onClick={openModal(
                                                        data.video
                                                    )}
                                                >
                                                    Click to Play{" "}
                                                    <i className="fa fa-play-circle fa-lg"></i>
                                                </button>

                                                {/* <img
                                                alt="NeoPic"
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    "/images/icon/play.svg"
                                                }
                                                width="15%"
                                                className=" mt-3"
                                                style={{ marginLeft: "-19px" }}
                                            /> */}
                                            </div>
                                        </div>
                                        <div className="mt-3">
                                            {/* <h4 className="title text-left m-4">
                                            <b>
                                                <u>{data.name}</u>
                                            </b>
                                        </h4> */}
                                            {data.details &&
                                                data.details.map(
                                                    (details, keyd) => {
                                                        return (
                                                            <p
                                                                key={keyd}
                                                                className="text-dark"
                                                                style={{
                                                                    fontSize:
                                                                        "13px",
                                                                }}
                                                                dangerouslySetInnerHTML={{
                                                                    __html: details,
                                                                }}
                                                            ></p>
                                                        );
                                                    }
                                                )}
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div
                                    className="col-xl-6 col-lg-6 col-md-6 col-12 mb-5"
                                    key={key}
                                >
                                    <div
                                        className={
                                            data.class + " radius-box p-3"
                                        }
                                    >
                                        <div className="row mb-1 item-desk">
                                            <img
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    data.authorThumb
                                                }
                                                alt="NeoGrowth "
                                                width={"30%"}
                                                className="radius-box"
                                            />
                                        </div>
                                        <div className="d-flex justify-content-evenly">
                                            <img
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    data.authorThumb
                                                }
                                                alt="NeoGrowth "
                                                width={"30%"}
                                                className="radius-box y-border item-mobile"
                                            />
                                            <div className="align-self-center m-4 text-center">
                                                <h4 className="title text-center">
                                                    <b>{data.name}</b>
                                                </h4>
                                                <p>
                                                    {" "}
                                                    <b>{data.city}</b>
                                                </p>
                                                <button
                                                    className="btn btn-sm btn-primary btn-hover-primary mt-3"
                                                    type="button"
                                                    aria-label="Click to Play"
                                                    onClick={openModal(
                                                        data.video
                                                    )}
                                                >
                                                    Click to Play{" "}
                                                    <i className="fa fa-play-circle fa-lg"></i>
                                                </button>

                                                {/* <img
                                                alt="NeoPic"
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    "/images/icon/play.svg"
                                                }
                                                width="15%"
                                                className=" mt-3"
                                                style={{ marginLeft: "-19px" }}
                                            /> */}
                                            </div>
                                        </div>
                                        <div className="mt-3">
                                            {/* <h4 className="title text-left m-4">
                                            <b>
                                                <u>{data.name}</u>
                                            </b>
                                        </h4> */}
                                            {data.details &&
                                                data.details.map(
                                                    (details, keyd) => {
                                                        return (
                                                            <p
                                                                key={keyd}
                                                                className="text-dark"
                                                                style={{
                                                                    fontSize:
                                                                        "13px",
                                                                }}
                                                                dangerouslySetInnerHTML={{
                                                                    __html: details,
                                                                }}
                                                            ></p>
                                                        );
                                                    }
                                                )}
                                        </div>
                                        {/* <h4 className="title text-center m-4">
                                        <b>
                                            <u>{data.name}</u>
                                        </b>
                                    </h4> */}
                                        {/* {data.details &&
                                        data.details.map((details, keyd) => {
                                            return (
                                                <p
                                                    key={keyd}
                                                    className="text-dark"
                                                    style={{ fontSize: "13px" }}
                                                    dangerouslySetInnerHTML={{
                                                        __html: details,
                                                    }}
                                                ></p>
                                            );
                                        })} */}
                                    </div>
                                </div>
                            );
                        })}
                </div>
            </div>
            <div
                className={`modal ${isModalOpen ? "show" : ""}`}
                style={{
                    display: isModalOpen ? "block" : "none",
                    background: "#b5c4a875",
                }}
            >
                <div
                    className="modal-dialog modal-dialog-centered modal-dialog-scrollable"
                    style={{
                        maxWidth: "1000px",
                        overflow: "visible",
                        borderRadius: "0.75em",
                    }} // Adjust modal width
                >
                    <div
                        className="modal-content"
                        style={{ position: "relative", overflow: "visible" }}
                    >
                        {/* Close button */}
                        <button
                            type="button"
                            className="btn-close custom-close-button"
                            style={{
                                position: "absolute",
                                top: "-15px",
                                right: "-5px",
                                backgroundColor: "#fff",
                                border: "1px solid #ccc",
                                borderRadius: "50%",
                                padding: "5px",
                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                zIndex: 1050,
                                width: "25px",
                                height: "25px",
                            }}
                            aria-label="Close"
                            onClick={closeModal}
                        ></button>

                        <div className="modal-body padding-0">
                            {videoSrc && (
                                <iframe
                                    width="100%"
                                    height="450" // Adjust height as needed
                                    src={videoSrc}
                                    title="YouTube video player"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    referrerPolicy="strict-origin-when-cross-origin"
                                    allowFullScreen
                                ></iframe>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

ClientstoriesContainer.propTypes = {
    classOption: PropTypes.string,
};

export default ClientstoriesContainer;
